import React, { FC } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { convertDateToString, getFormattedTime, getTime } from "../../../../services/utilities/dateFormatting";
import { WizardSummaryLayout } from '../../../wizard/wizard-summary-layout';

interface SummaryFormProps {
    taskDescription: string;
    taskProcedure: string;
    onBack: (event: any) => void;
    vingCardDescription: { cardType: string, door: string };
}

const VingCardSummary: FC<SummaryFormProps> = ({ onBack, taskDescription, taskProcedure, vingCardDescription }) => {
    const { translate } = useLocale();
    const {values} = useFormikContext<any>();

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.task)}: <span className="text-sm text-black">{taskProcedure}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.procedure)}: <span className="text-sm text-black">{taskDescription}</span></h4>
            </div>
        </div>
        <div className="flex flex-row pt-3">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.cardTypes)}: <span className="text-sm text-black">{vingCardDescription.cardType}</span></h4>
                {values.checkOutDate && values.checkOutTime ? <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.checkOutDate)}: <span className="text-sm text-black">{`${convertDateToString(values.checkOutDate)} ${getFormattedTime(getTime(values.checkOutTime))}`}</span></h4> : null}
                {values.checkInDate && values.checkInTime ? <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.checkInDate)}: <span className="text-sm text-black">{`${convertDateToString(values.checkInDate)} ${getFormattedTime(getTime(values.checkInTime))}`}</span></h4> : null}
                {values.userExpirationDate && values.userExpirationTime ? <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.checkOutDate)}: <span className="text-sm text-black">{`${convertDateToString(values.userExpirationDate)} ${getFormattedTime(getTime(values.userExpirationTime))}`}</span></h4> : null}
                {values.roomNumber && <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.mainRoomNumber)}: <span className="text-sm text-black">{values.roomNumber}</span></h4>}
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.doors)}: <span className="text-sm text-black">{values.selectedDoors ? values.selectedDoors.join(",") : "No selected doors"}</span></h4>
            </div>
        </div>
    </WizardSummaryLayout>
}

export default VingCardSummary;